import { Component, OnInit, HostListener } from '@angular/core';
import { MultistepsService } from '@app/modules/applicant/base';
import { SessionService, StepsIdEnum, RequestTypesEnum, ApplicantMessageEnum, LookupsService, ConstantsService, CompaniesEnum, EnvironmentService } from '@app/base/core';
import { FormGroup, Validators } from '@angular/forms';
import { CanComponentDeactivate } from '@app/base/shared';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AlertService } from '@app/base/alerts/alert.service';

@Component({
  selector: 'app-type',
  templateUrl: './type.component.html',
  styleUrls: ['./type.component.css']
})
export class TypeComponent implements OnInit, CanComponentDeactivate {
  form: FormGroup;
  requestType: string;
  stepsIdEnum: typeof StepsIdEnum = StepsIdEnum;
  requestTypesEnum: typeof RequestTypesEnum = RequestTypesEnum;
  alertMsg: any = [];
  applicantMessageEnum: typeof ApplicantMessageEnum = ApplicantMessageEnum;
  companiesEnum: typeof CompaniesEnum = CompaniesEnum;
  builderFirstUrl: any;

  @HostListener('window:beforeunload', ['$event']) onBeforeUnload(event) {
      event.preventDefault();
      // Specially for chrome...
      event.returnValue = this.constantSvc.changes;
    }

  constructor(public wizardSvc: MultistepsService, public sessionSvc: SessionService, public environmentSvc: EnvironmentService,
    public lookupSvc: LookupsService, private alertService: AlertService, public constantSvc: ConstantsService) {
    this.wizardSvc.syncActiveStep(StepsIdEnum.TYPE);
  }

  // used to subscribe to services and call methods to initiate functionality
  ngOnInit() {
    const subscribe = this.lookupSvc.commonLookupsLoaded$.subscribe(val => {
      if (subscribe && val) {
        subscribe.unsubscribe();
      }
      if (val) {
         this.alertMsg = (this.lookupSvc.bannerMessages.find( x => x.itemName === 'Type'
        ));
        this.alertService.info(this.alertMsg.message);
      }
    });
      this.form = this.wizardSvc.getStepById(this.stepsIdEnum.TYPE).form;
      this.builderFirstUrl = this.environmentSvc.builderFirstURL;

      this.setRequiredValidator(['question62']);
      
  }
  next() { this.wizardSvc.nextStep(); }
  back() { this.wizardSvc.previousStep(); }
  canDeactivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot, nextState: RouterStateSnapshot) {
    return this.wizardSvc.canDeactivateStep(route, state, nextState); }

  getControlValue(controlName: string) { return this.form.get(controlName).value; }
  setControlNull(args: any[]) { args.forEach(arg => { this.form.controls[arg].patchValue(null); }); }
  clearValidators(args: any[]) {
    args.forEach(arg => {
    this.form.controls[arg].clearValidators();
    this.form.controls[arg].updateValueAndValidity();
  }); }
  setRequiredValidator(args: any[]) { args.forEach(arg => {
    this.form.controls[arg].setValidators([Validators.required]);
    this.form.controls[arg].updateValueAndValidity();
  });
   }

    ldcCheck(): boolean {
        return this.sessionSvc.paramLdc === this.companiesEnum.GA;
    }

  // used to put up questionary for user
  onQuestionCheck(control) {
    switch (control.controlName) {
        case 'question62':          
         if (this.wizardSvc.paramRequestType.toUpperCase() === this.requestTypesEnum.Residential.toUpperCase()) {
          this.setControlNull(['question1', 'question2', 'question3', 'question4', 'question5', 'question6', 'question7', 'question40', 'question60']);
          if (control.value === this.constantSvc.Yes) {
            this.setRequiredValidator(['question1']);
           }
          if (control.value === this.constantSvc.No) {
           this.setRequiredValidator(['question1']);
         }
         this.clearValidators(['question2', 'question3', 'question4', 'question5', 'question6', 'question7']);
        }
        else if (this.wizardSvc.paramRequestType.toUpperCase() === this.requestTypesEnum.Commercial.toUpperCase()) {
          this.setControlNull(['question16','question17', 'question18', 'question19', 'question20', 'question21']);
          if (control.value === this.constantSvc.Yes) {
            this.setRequiredValidator(['question16']);
           }
          if (control.value === this.constantSvc.No) {
           this.setRequiredValidator(['question16']);
         }
         this.clearValidators(['question17','question18', 'question19', 'question20', 'question21']);
        }
        break;

      case 'question1': // Residential
        this.setControlNull(['question2', 'question3', 'question4', 'question5', 'question6', 'question7', 'question40', 'question60']);
        if (control.value === this.constantSvc.residentialType) {
          this.setRequiredValidator(['question2']);
          this.clearValidators(['question40']);
          this.clearValidators(['question60']);
        } else {
          this.setRequiredValidator(['question40']);
          this.clearValidators(['question2']);
        }
        this.clearValidators(['question3', 'question4', 'question5', 'question6', 'question7']);

        break;
      case 'question2':
        this.setControlNull(['question3', 'question4', 'question5', 'question6', 'question7', 'question40', 'question60']);
        if (control.value === this.constantSvc.Yes) {
          this.setRequiredValidator(['question3']);
          this.clearValidators(['question5']);
        }
        if (control.value === this.constantSvc.No) {
          this.setRequiredValidator(['question5']);
          this.clearValidators(['question3']);
        }
        this.clearValidators(['question4', 'question6', 'question7', 'question40', 'question60']);
        break;
      case 'question3':
        this.setControlNull(['question4', 'question5', 'question6', 'question7', 'question40', 'question60']);
        this.clearValidators(['question4', 'question5', 'question6', 'question7', 'question40', 'question60']);
        if (control.value === this.constantSvc.No) { this.setRequiredValidator(['question4']); }
        if (control.value === this.constantSvc.Yes) {
          this.clearValidators(['question4']);
          this.setControlNull(['question4']);
        }
        break;
      case 'question4':
        this.setControlNull(['question5', 'question6', 'question7', 'question40', 'question60']);
        this.clearValidators(['question5', 'question6', 'question7', 'question40', 'question60']);
        break;
      case 'question5':
        this.setControlNull(['question6', 'question7', 'question40', 'question60']);
        if (control.value === this.constantSvc.Yes) {
          this.setRequiredValidator(['question6']);
          this.clearValidators(['question7']);
        }
         if (control.value === this.constantSvc.No) {
          this.setRequiredValidator(['question6']);
          this.setRequiredValidator(['question7']);
        }
        this.clearValidators(['question40', 'question60']);
        break;
      case 'question6':
      case 'question7':
        this.setControlNull(['question40', 'question60']);
        this.clearValidators(['question40', 'question60']);
        break;
      case 'question40':
        if (control.value === this.constantSvc.No) {
          this.setRequiredValidator(['question60']);
        } else {
          this.setControlNull(['question60']);
          this.clearValidators(['question60']);
        }
        break;
      case 'question60':
        break;
      case 'question16': // Commercial
        this.setControlNull(['question17', 'question18', 'question19', 'question20', 'question21']);
        this.setRequiredValidator(['question17']);
        this.clearValidators(['question18', 'question19', 'question20', 'question21']);
        break;
      case 'question17':
        this.setControlNull(['question18', 'question19', 'question20', 'question21']);
        if (control.value === this.constantSvc.Yes) {
          this.setRequiredValidator(['question18']);
          this.clearValidators(['question20']);
        }
        if (control.value === this.constantSvc.No) {
          this.setRequiredValidator(['question20']);
          this.clearValidators(['question18']);
        }
        this.clearValidators(['question19', 'question21']);
        break;
      case 'question18':
        this.setControlNull(['question19', 'question20', 'question21']);
        if (control.value === this.constantSvc.Yes) {
          this.clearValidators(['question19']);
          this.setControlNull(['question19']);
      }
        if (control.value === this.constantSvc.No) { this.setRequiredValidator(['question19']); }
        break;
      case 'question19':
        this.setControlNull(['question20', 'question21']);
        break;
      case 'question20':
        this.clearValidators(['question21']);
        if (control.value === this.constantSvc.Yes) { this.setControlNull(['question21']); }
        if (control.value === this.constantSvc.No) { this.setRequiredValidator(['question21']); }
        break;
      default:
        return;
    }
  }
}
